import React from "react";
import { EligibilityContainer } from "../../../containers";

const Eligibility = (props) => {
  return <EligibilityContainer {...props} />;
};

export default Eligibility;
